import React from 'react';
import './Cards.css';
import CardItem from './CardItem';
import game from '../images/games.jpg';
import game1_eoz from '../images/game1_eoz.png';
import game2_bt from '../images/game2_bt.png';
import backend from '../images/backend.jpg';
import webdev from '../images/webdev.jpg';
import ml from '../images/ml.jpg';

import webdev_vera from '../images/vera.gif';
import other_api from '../images/api.gif';
import audio from '../images/audio.png';
import api from '../images/api.png'
import sort from '../images/selection.gif'
import app from '../images/app.png'


function Cards() {
  return (
    <div className='cards'>
      <h1>Completed Projects</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
          <li>
          <CardItem
              src={ml}
              text='Machine Learning'
              label='Machine Learning'
              path='/services'
              text_para= {
                <ul class="timeline">
                    <li>
	              			<h2 id="sec2head">
                        Vera
                            <br></br>
                            Co-Founder and Techninal Lead
                      </h2>
				              <p id="sec2body"><br></br> Vera is an proposed mobile application that uses machine learning and big data to provide accurate and immediate diagnosis and fun treatment for children suffering from speech sound disorders wherein patients have difficulties in articulation and phonology.
<br/>In the first phase, our app will carry out a fun and interactive diagnosis test with the child with the help of a chatbot, deep learning algorithm and a pronunciation database. 
<br/>In the second phase, treatment is provided through personalised and interactive speech therapy through gamification and AI technology.

                     </p>
                     <img src={app} width="150" height="290"/>

                   </li>
                   <br></br>	
              </ul>  
              }
            />
         
 <CardItem
              src={webdev}
              text='Web Development Projects'
              label='Web Development Projects'
              path='https://tratikdixit.github.io/vera/'
              text_para= {
                <ul class="timeline">
                    <li>
	              			<h2 id="sec2head">
                            Vera: Website
                            <br></br>
                            <a href="https://tratikdixit.github.io/vera/" > Click here to access</a>
                      </h2>
				              <p id="sec2body"><br></br> I created this website single handedly for a project I am working on. 
                        Vera is an AI speech therapist that makes use of Machine Learning and Natural Language Processing to provide accurate and cost effective speech therapy.
                     </p>
                     <img src={webdev_vera} width="280" height="190"/>
                   </li>
                   <br></br>	
              </ul>  
              }
            /> 
                   
            </li>
           
<li>
            <CardItem
              src={backend}
              text='Programming-based Projects'
              label='Programming'
              text_para= {
                <ul class="timeline">
                    <li>
	              			<h2 id="sec2head">
                      Sorting Visualiser
                            <br></br>
                            <a href="https://tratikdixit.github.io/SortingVisualizer/" > Click here to access</a>
                      </h2>
				              <p id="sec2body"><br></br> This project is deployed as a react website that can visualise different types of sorting algorithms.
                     </p>
                     <img src={sort} width="280" height="190"/>
                     <br></br>                 
                   </li>
                   <br></br>	
                   <li>
	              			<h2 id="sec2head">
                        Audio-Visualizer
                            <br></br>
                            <a href="https://github.com/TratikDixit/visualizing-audio-data" > Click here to know more</a>
                      </h2>
				              <p id="sec2body"><br></br> This is a python project that helps visualize audios in (.wav) format as a wavelength graph and a spectogram.
                     </p>
                     <img src={audio} width="280" height="190"/>
                     <br></br>                 
                   </li>
                   <br></br>	
              </ul>  
              }
            />   


            <CardItem
              src={api}
              text='API Projects'
              label='API'
              text_para= {
                <ul class="timeline">
                    <li>
	              			<h2 id="sec2head">
                      API-Projects
                            <br></br>
                            <a href="https://tratikdixit.github.io/api-projects/" > Click here to access</a>
                      </h2>
				              <p id="sec2body"><br></br> These are 3 API based projects in which I have used different types of APIs - CoinGecko (Open API), IMBD (Key-Authorised) and Unsplash (Client Authorised) using different techniques like fetch and axios.
                     </p>
                     <br></br>
                          <h2 id="sec2head">Crypto Price Generator
                           
                            <br></br>   
                          </h2>
                      <br></br>
                       
                          <h2 id="sec2head">Moodboard Creator
                       
                            <br></br>   
                          </h2>
                   <br></br>                       
                          <h2 id="sec2head">IMDB Movie Browser
                          
                            <br></br>   
                          </h2>
                          <img src={other_api} width="280" height="190"/>

                                       <br></br>

                   </li>
                   <br></br>	
              </ul>  
              }
            />  

            </li>
            <CardItem
              src={game}
              text='Games'
              label='Games'
              text_para= {
                <ul class="timeline">
                    <li>
	              			<h2 id="sec2head">
                            EYE OF THE ZODIAC 
                            <br></br>
                            <a href="https://github.com/TratikDixit/Engg1340_Group_Project_GroupNo_120" > Click here to know more</a>
                      </h2>
				              <p id="sec2body"><br></br> This ASCII Rougelike Game game was developed in collaboration with Yashwardhan Kumar (HKU CS Student).
This is a text based adventure game. Incorporates the elements of classic roguelike games. Players have to navigate through a maze-like dungeon while fighting enemies in order to escape.
                     </p>
                     <img src={ game1_eoz } width="280" height="190"/>
                   </li>
                   <br></br>	
                  <li>
		            		<h2 id="sec2head">
                    Big Two - Card Game
                    <br></br>
                            <a href="https://github.com/TratikDixit/BigTwoGame" > Click here to know more</a>
                    </h2>
			            	<p id="sec2body"><br></br> This is a multi-player implementation of the popular card game Big Two. <br></br><br></br>
                   </p>
                   <img src={game2_bt} width="280" height="190"/>
                  </li>
              </ul>  
              }
            />
                

          </ul>
        </div>
      </div>
     
      
    </div>
  );
}

export default Cards;
